import { render } from "./agent-tips.vue?vue&type=template&id=723f85fa"
import script from "./agent-tips.js?vue&type=script&lang=js"
export * from "./agent-tips.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__